import { SystemRole } from '@/entities/authentication';
import { userStore } from '@/entities/user';

export function getDefaultPageByRole() {
  const userRole = userStore.state?.roleName;

  switch (userRole) {
    case SystemRole.EventAdmin:
    case SystemRole.EventUser:
      return '/events';
    default:
      return '/reporting';
  }
}
